import PropTypes from 'prop-types'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Skeleton from '@mui/material/Skeleton'
import IconButton from '@mui/material/IconButton'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const BoxChart = ({ title, children, loading, className, expandable, expanded, onToggleExpand }) => (
  <Box className='h-full relative'>
    <Typography color='primary' variant='subtitle1'>
      {title}
    </Typography>
    {expandable && !loading && (
      <IconButton
        size='small'
        onClick={onToggleExpand}
        title={expanded ? 'Collapse' : 'Expand'}
        style={{ position: 'absolute', top: 0, right: 0, zIndex: 10 }}
      >
        <FontAwesomeIcon icon={['fal', expanded ? 'compress' : 'expand']} size='xs' />
      </IconButton>
    )}
    <div className={['absolute inset-x-0 top-5 bottom-0', className].join(' ')}>
      {loading ? <Skeleton width='100%' height='100%' style={{ transform: 'scale(1, 0.96)' }} /> : children}
    </div>
  </Box>
)

BoxChart.propTypes = {
  title: PropTypes.node,
  children: PropTypes.node,
  loading: PropTypes.bool,
  className: PropTypes.string,
  expandable: PropTypes.bool,
  expanded: PropTypes.bool,
  onToggleExpand: PropTypes.func
}

export default BoxChart
